import SearchPanel from '#src/components/search-panel.jsx';
import Input from 'lib/components/input.jsx';
import React, { useContext, useEffect } from 'react';
import useOrdersDeps from './use-orders-deps.jsx';
import useOrders from '#src/@connections/use-orders.js';
import LanguageModal from './languageModal.jsx';
import ActionsButton from './actionsButton.jsx';
import SearchResults from '#components/search-results.jsx';
import { LoadingIndicator, LoadingSkeleton } from 'lib/components/loading.jsx';
import { addClasses, cn } from '#lib/helpers/class.js';
import { UserContext } from '#src/index.jsx';
export default function Orders() {
    const {
        data,
        flags,
        selectedRows,
        setSelectedRows,
        isAllSelected,
        setIsAllSelected,
        importFns,
        setImportFns,
        onSubmitSearch,
        importMutation,
        importLoading,
        setPageNumber,
        fetchNextPage,
        resetSelected,
        params
    } = useOrders();

    const { maxDate, setMaxDate, minDate, setMinDate, isShown, setIsShown, page, setPage, renderedData, columnProps } =
        useOrdersDeps({
            selectedRows,
            isAllSelected,
            data,
            setSelectedRows,
            setIsAllSelected,
            importFns,
            importLoading,
            resetSelected,
            setImportFns
        });

    const { getLanguage } = useContext(UserContext);
    const language = getLanguage();

    return (
        <div>
            <div className="flex flex-col pt-[116px] px-3">
                <div className="absolute top-0 pt-16 pl-1">
                    <span className="text-2xl">{_t.orders.importTitle()}</span>
                </div>
                <SearchPanel searchParams={params} onSubmit={onSubmitSearch} busy={flags.isRefetching}>
                    <Input.Full
                        label={_t.edit.fields.startDate()}
                        name="startDate"
                        placeholder="start-date"
                        key="start-date"
                        type="date"
                        className="flex-shrink w-1/5"
                        inputClassName={addClasses('pl-4')}
                        max={maxDate}
                        onChange={(e) => setMinDate(e.target.value)}
                    />
                    <Input.Full
                        label={_t.edit.fields.endDate()}
                        name="endDate"
                        placeholder="end-date"
                        key="end-date"
                        type="date"
                        className="flex-shrink w-1/5"
                        min={minDate}
                        onChange={(e) => setMaxDate(e.target.value)}
                    />
                    <Input.Full
                        label={_t.edit.fields.query()}
                        name="query"
                        placeholder={_t.connections.query()}
                        key="nameOrNumber"
                        type="search"
                        className="flex-shrink w-1/2"
                    />
                </SearchPanel>
                <div className="flex flex-col items-center">
                    <ActionsButton
                        className="w-auto h-[35px] ml-auto mb-6 mx-4"
                        onClick={(disabled) => {
                            if (disabled) return;
                            setImportFns(selectedRows);
                            setIsShown(true);
                        }}
                        disabled={selectedRows.length === 0 && !isAllSelected}
                    />
                    <LanguageModal
                        isShown={isShown || false}
                        onClose={() => {
                            setIsShown(false);
                        }}
                        onClick={importMutation}
                        language={language}
                    />
                    {(flags.isLoading || flags.isRefetching) && (
                        <LoadingSkeleton className="h-screen flex items-center justify-center fixed inset-4 ">
                            <LoadingIndicator></LoadingIndicator>
                        </LoadingSkeleton>
                    )}
                    <div className="w-full">
                        {!flags.isLoading && (
                            <div className={cn(flags.isRefetching && 'opacity-50 pointer-events-none')}>
                                <SearchResults
                                    stickyHeaders={true}
                                    data={renderedData}
                                    {...columnProps}
                                    hasNextPage={!data?.pages.at(-1)?.lastPage}
                                    fetchNextPage={() => {
                                        setPage(page + 1);
                                        setPageNumber(page + 1);
                                        fetchNextPage();
                                    }}
                                    isFetchingNextPage={flags.isFetchingNextPage}
                                    paginated
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
